import { useNavigate } from 'react-router-dom';

import AlertsCenter from '../../components/AlertsCenter';
import { PATHS } from '../../paths';
import { useSidePanel } from '../../providers/SidePanelProvider';

/**
 * The Alerts Center as a full-screen route, which is what `/alerts` is below
 * `xl`. At `xl+` the center is a side panel instead and `AlertsRouteGate`
 * redirects into it, so this pane only ever renders on the narrow layout.
 *
 * Closing collapses to the assistant thread — the same destination the panel's
 * X gives at `xl+`, reached by navigation because there is no column to swap. A
 * viewer without `feat-assistant` is bounced on to the dashboard by
 * `AssistantRouteGate`, which is the right fallback: both are "somewhere other
 * than my alerts".
 *
 * Not an `Entity.Pane`: the center brings its own pinned header and internal
 * scroller, and the entity chrome would stack a second header above it.
 */
const AlertsPane = () => {
  const navigate = useNavigate();
  const { showAssistant } = useSidePanel();

  // Reset the panel's selection as well as navigating: a center carried down
  // from `xl+` left `content: 'alerts'` behind it, and closing here without
  // clearing that would reopen the center — not the assistant — the next time
  // the viewport widens. The X means the same thing at both sizes.
  const handleClose = () => {
    showAssistant();
    void navigate(PATHS.ASSISTANT);
  };

  return <AlertsCenter onClose={handleClose} className="min-h-full" />;
};

export default AlertsPane;
